/** @flow */

import type { State } from "@store/reducers";
import type { PropertiesSchema } from "@types";
import type { FocusListsType } from "@modules/reporting/reducer/focus-lists/types";
import type {
  EmployeeReport,
  Reports,
  DefaultReports,
} from "@modules/reporting/reducer/focus-lists/employee/types";

export type GetReportsSchema = (state: State) => ?PropertiesSchema;
export type GetReportToSave = (state: State) => ?EmployeeReport;

export const getEmployeeFocusLists = (state: State): $PropertyType<FocusListsType, "employee"> =>
  state.reporting.focusLists.employee;

export const getReports = (state: State): Reports => getEmployeeFocusLists(state).reports;

export const getDefaultReports = (state: State): DefaultReports =>
  getReports(state).defaultReports || [];

export const getMyReports = (state: State): DefaultReports => getReports(state).myReports || [];

export const getReportsSchema = (state: State): ?PropertiesSchema => getReports(state).schema;

export const getReportToSave = (state: State): ?EmployeeReport => getReports(state).reportToSave;

export const isLoading = (state: State): boolean =>
  state.reporting.focusLists.employee.reports.requestsInProgress > 0;
